export default "__VITE_ASSET__D60Ajr$S__"